module.exports = __webpack_public_path__ + "media/images/soar/PlameetFavicon-9f4fd0a97cbb8aeefd6aa8d156a619e8.png";